interface AnalyticsEvent {
  event: string;
  properties?: Record<string, any>;
  userId?: string;
}

class Analytics {
  private isEnabled: boolean;

  constructor() {
    this.isEnabled = import.meta.env.PROD && !import.meta.env.VITE_DISABLE_ANALYTICS;
  }

  track(event: string, properties?: Record<string, any>, userId?: string) {
    if (!this.isEnabled) {
      console.log('Analytics (dev):', { event, properties, userId });
      return;
    }

    try {
      // Replace with your analytics service (e.g., Mixpanel, Amplitude, etc.)
      // Example for Mixpanel:
      // mixpanel.track(event, properties);
      
      // Example for Google Analytics 4:
      // gtag('event', event, properties);
      
      console.log('Analytics:', { event, properties, userId });
    } catch (error) {
      console.error('Analytics error:', error);
    }
  }

  identify(userId: string, traits?: Record<string, any>) {
    if (!this.isEnabled) {
      console.log('Analytics identify (dev):', { userId, traits });
      return;
    }

    try {
      // Replace with your analytics service
      // mixpanel.identify(userId);
      // mixpanel.people.set(traits);
      
      console.log('Analytics identify:', { userId, traits });
    } catch (error) {
      console.error('Analytics identify error:', error);
    }
  }

  page(name: string, properties?: Record<string, any>) {
    if (!this.isEnabled) {
      console.log('Analytics page (dev):', { name, properties });
      return;
    }

    try {
      // Replace with your analytics service
      // gtag('config', 'GA_MEASUREMENT_ID', { page_title: name, ...properties });
      
      console.log('Analytics page:', { name, properties });
    } catch (error) {
      console.error('Analytics page error:', error);
    }
  }
}

export const analytics = new Analytics();

// Event tracking helpers
export const trackUserRegistration = (method: 'email' | 'referral') => {
  analytics.track('user_registered', { method });
};

export const trackGoalCreated = (goalLength: number) => {
  analytics.track('goal_created', { goal_length: goalLength });
};

export const trackGoalCompleted = (completionTime: number) => {
  analytics.track('goal_completed', { completion_time_hours: completionTime });
};

export const trackPreferencesUpdated = (changes: string[]) => {
  analytics.track('preferences_updated', { changes });
};

export const trackError = (error: string, context?: string) => {
  analytics.track('error_occurred', { error, context });
};